import AOS from "aos";
import "aos/dist/aos.css";
import '../src/css/Style.css';
import '../src/css/Responsive.css';
import './App.css';
import Main from './Main';
import { useEffect } from "react";
function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="">
      <Main />
    </div>
  );
}

export default App;
